import { useEffect, useState } from "react";
import { getLoginUrl } from "../authConfig";
import SystemTransition from "../components/SystemTransition";

export default function AuthGate({ children }) {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // ✅ Validar SOLO una vez
    const accessToken = localStorage.getItem("accessToken"); // 👈 CAMBIO
    const idToken = localStorage.getItem("idToken"); // fallback

    // Permitir callback sin validar
    if (window.location.pathname === "/callback") {
      setChecking(false);
      return;
    }

    // ✅ Preferimos AccessToken
    if (!accessToken && !idToken) {
      console.warn("⛔ No existe token — Redirigiendo al login");
      window.location.replace(getLoginUrl());
      return;
    }

    console.log("🔐 Token válido — acceso permitido");
    setChecking(false);
  }, []);

  if (checking) {
    return <SystemTransition
  title="Iniciando sesión segura"
  subtitle="Verificando tu identidad"
 />;
  }

  return children;
}
